// extracted by mini-css-extract-plugin
module.exports = {"container":"ExerciseDisplay_container__24-dZ","list":"ExerciseDisplay_list__3xjdL","exerciseData":"ExerciseDisplay_exerciseData__1dIPZ","set":"ExerciseDisplay_set__1svf2"};